/* eslint-disable react-hooks/exhaustive-deps */
import { AuthContext, } from "@/shared/presentation/context-api/providers/auth";
import React, { useContext, useEffect, useState } from "react";
var initialState = {
    clientWallet: undefined,
    clientWallets: [],
    setSelectedClientWallet: function () { return null; },
};
export var ClientWalletContext = React.createContext(initialState);
export var ClientWalletProvider = function (_a) {
    var children = _a.children;
    var clientWallets = useContext(AuthContext).clientWallets;
    var _b = useState(), clientWallet = _b[0], setClientWallet = _b[1];
    var setSelectedClientWallet = function (newClientWallet) {
        setClientWallet(newClientWallet);
    };
    useEffect(function () { return setClientWallet(clientWallets === null || clientWallets === void 0 ? void 0 : clientWallets[0]); }, [clientWallets]);
    return (React.createElement(ClientWalletContext.Provider, { value: {
            clientWallet: clientWallet,
            clientWallets: clientWallets,
            setSelectedClientWallet: setSelectedClientWallet,
        } }, children));
};
